<template>
  <v-app id="app">
    <home></home>
  </v-app>
</template>

<script>
import home from './components/home'

export default {
  name: 'App',
  components: {
    home
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue